import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';

import { FormilyWrappedIconComponent, formilyIconExtension } from './addons/material-icon.addon';
import { FormlyInstallationInputComponent } from './installation-input/installation-input.component';
import { FormlyinventoryInputComponent } from './asset-input/inventory-input.component';
import { FormlyInputButtonComponent } from './input-button/input-button.component';

@NgModule({
  imports: [
    FormlyModule.forRoot({
      validationMessages: [
        { name: 'required', message: 'This field is required' },
        { name: 'email', message: 'Invalid email format' }
      ],
      wrappers: [{ name: 'addons', component: FormilyWrappedIconComponent }],
      extensions: [{ name: 'addons', extension: { onPopulate: formilyIconExtension } }],
      types: [
        { name: 'inventory-select', component: FormlyinventoryInputComponent },
        { name: 'installation-select', component: FormlyInstallationInputComponent },
        { name: 'input-button', component: FormlyInputButtonComponent }
      ]
    })
  ],
  exports: [
    ReactiveFormsModule,
    FormlyModule,
    FormlyMaterialModule,
    MatNativeDateModule,
    FormlyMatDatepickerModule
  ],
  providers: []
})
export class SharedFormsModule {
  static forRoot(): ModuleWithProviders<SharedFormsModule> {
    return {
      ngModule: SharedFormsModule,
      providers: []
    };
  }
}
